define('plugin/news/view/NewsModuleItemView',['require','plugin/news/view/NewsItemView'],function (require) {

    var NewsItemView = require('plugin/news/view/NewsItemView');

    return NewsItemView.extend({

        template: '#news_item_module_view'

    });

});
